export default {
  mainMenu: {
    en: 'Main menu',
  },
}
